export default class VisibilityConditionController {

    calculatorController;

    constructor(CalculatorController) {
        this.calculatorController = CalculatorController;
    }
    
    isFieldOptionShouldBeDisplayed(field) {

        if (field.display_conditions.length === 0) {
            return field;
        }

        let showField = [];

        //check each condition in config
        field.display_conditions.forEach((condition) => {

            const conField = condition.field;
            const conOptions = condition.options;
            
            //Field don`t exist in form, so we display all options.
            if (!this.isConditionFieldExistInForm(conField)) {
                showField.push(true);
            } else {
                // If condition field was`t selected display all fields 
                if (!this.isConditionFieldWasSelected(conField)) {
                    showField.push(true);
                } else {
                    
                    const selectedProductField = this.getSelectedProductField(conField);
                    const isSelected = this.isConditionOptionsContainsSelectedOption(selectedProductField.selectedOption, conOptions)
           
                    showField.push(isSelected);
                }
            }
        });

        // if(field.label === 'Bevelled 10mm'){
        //     console.log(field);
        //     field.display_conditions.forEach((condition) => {
        //
        //         const selectedProductField = this.getSelectedProductField(condition.field);
        //         console.log(condition.field.label)
        //         console.log(condition.options.map(item=>item.label))
        //         if(selectedProductField?.selectedOption){
        //             console.log(selectedProductField.selectedOption.label)
        //
        //             console.log('shouldShow')
        //             console.log(!!condition.options.map(condition => condition.label).includes(selectedProductField.selectedOption.label))
        //         }
        //     });
        //     console.log('showField');
        //     console.log(showField);
        //
        //     console.log('showField')
        //     console.log(showField)
        //     console.log(showField.every((e) => e === true))
        // }
        
        return showField.every((e) => e === true) ? field : false;
    }

    getSelectedProductField(conField) {
        return this.calculatorController.getSelectedFields().find(field => {
            return parseInt(field.id) === parseInt(conField.id);
        })
    }

    isConditionFieldExistInForm(conField) {
        return !!this.calculatorController.getFieldsList().find(field => {
            return parseInt(field.id) === parseInt(conField.id);
        })
    }

    isConditionOptionsContainsSelectedOption(selectedField, conditionOptions) {
        return !!conditionOptions.map(condition => condition.label).includes(selectedField.label)
    }

    isConditionFieldWasSelected(conField) {
        return !!this.calculatorController.getSelectedFields().find(field => {
            return parseInt(field.id) === parseInt(conField.id);
        })
    }
}